import axios from 'axios';

export default {
  state: {
    siteParams: null
  },
  getters: {
    getSiteParams: e => e.siteParams
  },
  mutations: {
    setSiteParams(state, options) {
      state.siteParams = options;
    }
  },
  actions: {
    async siteParams({ commit, getters }) {
      try {
        if (!getters.getSiteParams) {
          const result = await axios.get(
            `${process.env.VUE_APP_API}/service/params`
          );
          commit('setSiteParams', result.data);
        }
      } catch (e) {
        commit('setError', e.response.data.message);
        throw e;
      }
    },
    async errorReport({ commit }, form) {
      try {
        const result = await axios.post(
          `${process.env.VUE_APP_API}/service/error-report`,
          form
        );
        console.log(result.data);
        return result.data;
      } catch (e) {
        commit('setError', e.response.data.message);
        throw e;
      }
    }
  }
};
